import React from "react";
import { Button, Tabs, Form, Space } from "antd";
import { EditOutlined, SaveOutlined } from "@ant-design/icons";
import {
  EnhancementResponse,
  EnhancementField,
  EnhancementCase,
} from "../../../interfaces/IEnhancement";
import TabPane from "antd/es/tabs/TabPane";
import { renderCommonField } from "../CommonFields";

interface EnhancementProps {
  activeStep: number;
  handleFileChange: any;
  enhancementData: EnhancementCase | null;
  isLoading: boolean;
  error: string | null;
  editMode: boolean;
  onToggleEditMode: () => void;
  onFieldChange: (sectionKey: string, fieldId: string, value: string) => void;
  onSaveChanges: () => void;
  editedFields: Record<string, Record<string, string>>;
  handleDeficiencyModal?: any;
  closeDeficiencyModal?: any;
  deficiencyModal: boolean;
  deficiencyQuestions?: any;
  previewDocumentUrl: string;
  setDocumentName: any;
  handleDeficiencyModalAfterSave: any;
}

const Enhancement: React.FC<EnhancementProps> = ({
  enhancementData,
  isLoading,
  error,
  handleFileChange,
  editMode,
  onToggleEditMode,
  onFieldChange,
  onSaveChanges,
  editedFields,
}) => {
  const [form] = Form.useForm();

  const renderTabContent = (stepTitle: string) => {
    if (!enhancementData) {
      return <div>No data available</div>;
    }

    const responseKeys = [
      "ihxEnhancementResponses",
      "cghsEnhancementResponse",
      "echsEnhancementResponse",
      "starHealthEnhancementResponse",
      "vidalEnhancementResponse",
    ];

    for (const key of responseKeys) {
      const data = enhancementData[key];
      if (Array.isArray(data) && data.length > 0) {
        const firstCase = data[0];
        if (isEnhancementCase(firstCase) && stepTitle in firstCase) {
          const sectionData = firstCase[stepTitle];
          if (Array.isArray(sectionData)) {
            return (
              <Form form={form}>
                {sectionData?.map((field: EnhancementField, index: number) => (
                  <Form.Item
                    key={field.id}
                    label={field?.label?.toUpperCase()}
                    style={{ fontWeight: "600" }}
                  >
                    {renderCommonField({
                      field,
                      index,
                      isReadOnly: !editMode || !field.updatable,
                      onFieldChange: (_, fieldId, value) =>
                        onFieldChange(key, fieldId, value),
                      handleFileChange,
                      value: editedFields[key]?.[field.id] ?? field.data,
                      isFileUploadDisabled: !editMode,
                      key: key,
                    })}
                  </Form.Item>
                ))}
              </Form>
            );
          }
        }
      }
    }

    return <div>No data for this section</div>;
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  function isEnhancementCase(obj: any): obj is EnhancementCase {
    return obj !== null && typeof obj === "object";
  }

  // return (
  //   <div>
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "space-between",
  //         alignItems: "center",
  //         marginBottom: 16,
  //       }}
  //     >
  //       <h1>ENHANCEMENT</h1>
  //       <Space>
  //         {editMode ? (
  //           <Button
  //             type="primary"
  //             icon={<SaveOutlined />}
  //             onClick={onSaveChanges}
  //           >
  //             SAVE
  //           </Button>
  //         ) : (
  //           <Button icon={<EditOutlined />} onClick={onToggleEditMode}>
  //             EDIT
  //           </Button>
  //         )}
  //       </Space>
  //     </div>
  //     <Tabs
  //       activeKey={activeStep.toString()}
  //       type="card"
  //       centered
  //       size="large"
  //       tabBarStyle={{ width: "100%" }}
  //       style={{ width: "100%" }}
  //     >
  //       {allWizardSteps.map((step) => (
  //         <TabPane tab={step.title.toUpperCase()} key={step.step.toString()}>
  //           {renderTabContent(step.title)}
  //         </TabPane>
  //       ))}
  //     </Tabs>
  //     <div style={{ marginTop: 16 }}>
  //       <Button
  //         onClick={onPrevious}
  //         disabled={activeStep === 0}
  //         style={{ marginRight: 8 }}
  //       >
  //         PREVIOUS
  //       </Button>
  //       {activeStep !== allWizardSteps.length - 1 && (
  //         <Button
  //           onClick={() => {
  //             if (activeStep === allWizardSteps.length - 1) {
  //               onComplete(activeStep);
  //             } else {
  //               onNext();
  //             }
  //           }}
  //           disabled={!allWizardSteps[activeStep].canNavigate}
  //         >
  //           {activeStep === allWizardSteps.length - 1 ? "SUBMIT" : "NEXT"}
  //         </Button>
  //       )}
  //     </div>
  //   </div>
  // );
};

export default Enhancement;
